export default __webpack_public_path__ + "static/media/orange-lines-left.dbff696b.svg";